import { useCallback, useMemo } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useModulePermission } from '../../shell/session/hooks/useModulePermission';
import { openCustomerCollectFromSale } from '../../customers/application/customerNavigation';
import type { SaleDetail } from '../domain/salesTypes';

export function useSaleCustomerCollect(detail: SaleDetail | null) {
  const navigation = useNavigation();
  const canCollect = useModulePermission('Customers', 'collect');

  const canCollectCustomer = useMemo(() => {
    if (!detail || !canCollect) return false;
    if (detail.status === 'voided') return false;
    if (!detail.fiadoCustomerId) return false;
    if (detail.pendingAmount == null || detail.pendingAmount <= 0) return false;
    return true;
  }, [canCollect, detail]);

  const onCollectCustomer = useCallback(() => {
    if (!detail?.fiadoCustomerId || detail.pendingAmount == null || detail.pendingAmount <= 0) {
      return;
    }
    openCustomerCollectFromSale(navigation, {
      customerId: detail.fiadoCustomerId,
      saleId: detail.id,
      suggestedAmount: detail.pendingAmount,
    });
  }, [detail, navigation]);

  return { canCollectCustomer, onCollectCustomer };
}
